export default "__VITE_ASSET__C87ScTze__"